// import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import './App.css';
import MainComponent from './MainComponent';
import AuthProvider from './providers/AuthProvider';
import SocketProvider from './providers/SocketProvider';
import { setup_axios_interceptor } from './services/HttpRequests';
import {store} from './store';
import { BrowserRouter } from 'react-router-dom';

setup_axios_interceptor(store);

function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
        <SocketProvider>
          <BrowserRouter>
            <MainComponent />
          </BrowserRouter>
        </SocketProvider>
      </AuthProvider>
    </Provider>
  );
}

export default App;
